import React, { createContext, useCallback, useContext, useState } from 'react';
import {
  dispatchGlobalDateChange,
  getDefaultDateRange,
  loadStoredDateRange,
  normalizeRangeEnd,
  normalizeRangeStart,
  presetToDateRange,
} from '../utils/dashboardDateRange';

const DateContext = createContext();

export const DateProvider = ({ children }) => {
  const initial = loadStoredDateRange();
  const [startDate, setStartDate] = useState(initial.start);
  const [endDate, setEndDate] = useState(initial.end);

  const updateDates = useCallback((start, end) => {
    const s = normalizeRangeStart(start);
    const e = normalizeRangeEnd(end);
    setStartDate(s);
    setEndDate(e);
    dispatchGlobalDateChange(s, e);
  }, []);

  const applyPreset = useCallback(
    (preset) => {
      const { start, end } = presetToDateRange(preset);
      updateDates(start, end);
    },
    [updateDates]
  );

  const resetToDefaultRange = useCallback(() => {
    const { start, end } = getDefaultDateRange();
    updateDates(start, end);
  }, [updateDates]);

  return (
    <DateContext.Provider
      value={{ startDate, endDate, updateDates, applyPreset, resetToDefaultRange }}
    >
      {children}
    </DateContext.Provider>
  );
};

export const useDateRange = () => {
  const context = useContext(DateContext);
  if (!context) {
    throw new Error('useDateRange must be used within a DateProvider');
  }
  return context;
};
